import { render, staticRenderFns } from "./bkrank.vue?vue&type=template&id=3cb9ee53&scoped=true"
import script from "./bkrank.vue?vue&type=script&lang=js"
export * from "./bkrank.vue?vue&type=script&lang=js"
import style0 from "./bkrank.vue?vue&type=style&index=0&id=3cb9ee53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb9ee53",
  null
  
)

export default component.exports